module.exports = {
  handle: (e, data) => {  
    dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
    dataLayer.push({
        event: 'e.storeLocatorSearch',
        resultCount: data.stores ? data.stores.length : 0,
    });
  }
}